/**
 * Derived from flubber@0.4.2 (MIT).
 * Adapted for dependency-free internal ESM use in anvil2.
 */
import { toPathString } from "./svg";

export type RingPoint = [number, number];
export type Ring = RingPoint[];

export function distance(a: RingPoint, b: RingPoint) {
  return Math.sqrt(
    (a[0] - b[0]) * (a[0] - b[0]) + (a[1] - b[1]) * (a[1] - b[1]),
  );
}

export function pointAlong(a: RingPoint, b: RingPoint, pct: number): RingPoint {
  return [a[0] + (b[0] - a[0]) * pct, a[1] + (b[1] - a[1]) * pct];
}

export function samePoint(a: RingPoint, b: RingPoint) {
  return distance(a, b) < 1e-9;
}

export function interpolatePoints(a: Ring, b: Ring, string: boolean) {
  const interpolators = a.map((point, index) =>
    interpolatePoint(point, b[index]),
  );

  return (t: number) => {
    const values = interpolators.map((interpolator) => interpolator(t));
    return string ? toPathString(values) : values;
  };
}

export function interpolatePoint(a: RingPoint, b: RingPoint) {
  return (t: number): RingPoint =>
    a.map((value, index) => value + t * (b[index] - value)) as RingPoint;
}

export function isFiniteNumber(value: unknown): value is number {
  return typeof value === "number" && Number.isFinite(value);
}

export function polygonArea(polygon: Ring) {
  let area = 0;
  let previous = polygon[polygon.length - 1];

  for (const point of polygon) {
    area += previous[1] * point[0] - previous[0] * point[1];
    previous = point;
  }

  return area / 2;
}

export function polygonLength(polygon: Ring) {
  let perimeter = 0;
  let previous = polygon[polygon.length - 1];

  for (const point of polygon) {
    perimeter += distance(previous, point);
    previous = point;
  }

  return perimeter;
}
